import { Component, Input } from '@angular/core';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';

@Component({
  selector: 'lp2-live-class-unavailable',
  templateUrl: './live-class-unavailable.component.html',
  styleUrls: ['./live-class-unavailable.component.scss'],
})
export class LiveClassUnavailable {
  @Input() activityPoints: Map<GamificationActivityType, number>;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-unavailable/live-class-unavailable.component.ts